module.exports = __webpack_public_path__ + "img/sympathetic_and_kind.56bda626.svg";